import axios from 'axios'
import { ApiResponse, AuthResponse, Role } from '../types'

const BASE_URL = import.meta.env.VITE_API_URL ?? '/api'

// Use plain axios (no interceptor) for auth endpoints to avoid circular dependencies
const authAxios = axios.create({ baseURL: BASE_URL, timeout: 30000 })

export const authApi = {
  register: (data: { email: string; password: string; displayName: string; phone?: string }) =>
    authAxios.post<ApiResponse<AuthResponse>>('/auth/register', data),

  login: (data: { email: string; password: string }) =>
    authAxios.post<ApiResponse<AuthResponse>>('/auth/login', data),

  verifyOtp: (data: { email: string; otp: string }) =>
    authAxios.post<ApiResponse<AuthResponse>>('/auth/verify-otp', data),

  resendOtp: (email: string) =>
    authAxios.post<ApiResponse<void>>('/auth/resend-otp', { email }),

  refresh: (refreshToken: string) =>
    authAxios.post<ApiResponse<AuthResponse>>('/auth/refresh', { refreshToken }),

  logout: (refreshToken: string) =>
    authAxios.post<ApiResponse<void>>('/auth/logout', { refreshToken }),

  switchRole: (role: Role, accessToken: string) =>
    authAxios.post<ApiResponse<AuthResponse>>(
      '/auth/switch-role',
      { role },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    ),

  forgotPassword: (email: string) =>
    authAxios.post<ApiResponse<void>>('/auth/forgot-password', { email }),

  resetPassword: (data: { email: string; otp: string; newPassword: string }) =>
    authAxios.post<ApiResponse<void>>('/auth/reset-password', data),
}
